import { render } from "./PdfUploadDropzone.vue?vue&type=template&id=988737cc&scoped=true"
import script from "./PdfUploadDropzone.vue?vue&type=script&lang=js"
export * from "./PdfUploadDropzone.vue?vue&type=script&lang=js"

import "./PdfUploadDropzone.vue?vue&type=style&index=0&id=988737cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-988737cc"]])

export default __exports__